import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { getConfig, saveConfig, type AppConfig } from "@/lib/config";
import { ScanPeerId } from "@/components/ScanPeerId";
import { useState, useEffect } from "react";

interface ConfigPageProps {
  onBack: () => void;
}

export function ConfigPage({ onBack }: ConfigPageProps) {
  const [config, setConfig] = useState<AppConfig>(getConfig());
  const [showScanner, setShowScanner] = useState(false);

  useEffect(() => {
    setConfig(getConfig());
  }, []);

  const handleSave = () => {
    saveConfig(config);
    onBack();
  };

  return (
    <div className="container mx-auto p-4 max-w-2xl">
      <Card>
        <CardHeader>
          <CardTitle className="text-2xl">配置页面</CardTitle>
          <CardDescription>配置JSONDB和打印机设置</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="desktopPeerId">桌面端 Peer ID</Label>
            <div className="flex gap-2">
              <Input
                id="desktopPeerId"
                type="text"
                value={config.desktopPeerId}
                onChange={(e) => setConfig({ ...config, desktopPeerId: e.target.value.trim() })}
                placeholder="扫描或手动输入桌面端 Peer ID"
              />
              <Button type="button" variant="secondary" onClick={() => setShowScanner(true)}>
                扫码录入
              </Button>
            </div>
            <p className="text-sm text-muted-foreground">
              将桌面端应用展示的二维码对准摄像头扫码，或手动输入 Peer ID。
            </p>
          </div>

          <div className="space-y-2">
            <Label htmlFor="pageTitle">页面标题名称</Label>
            <Input
              id="pageTitle"
              type="text"
              value={config.pageTitle}
              onChange={(e) => setConfig({ ...config, pageTitle: e.target.value })}
              placeholder="顾客信息填写"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="printerIP">打印机IP地址</Label>
            <Input
              id="printerIP"
              type="text"
              value={config.printerIP}
              onChange={(e) => setConfig({ ...config, printerIP: e.target.value })}
              placeholder="192.168.1.100:9100 或 192.168.1.100"
            />
            <p className="text-sm text-muted-foreground">
              格式：IP:端口（如 192.168.1.100:9100），如未指定端口则默认9100
            </p>
          </div>

          <div className="space-y-2">
            <Label htmlFor="logoURL">Logo图片地址</Label>
            <Input
              id="logoURL"
              type="url"
              value={config.logoURL}
              onChange={(e) => setConfig({ ...config, logoURL: e.target.value })}
              placeholder="https://example.com/logo.png"
            />
            <p className="text-sm text-muted-foreground">
              打印时将在顶部居中显示此logo图片（如为空则显示文字标题）
            </p>
          </div>

          <div className="space-y-2">
            <Label htmlFor="appendText">追加打印内容</Label>
            <Textarea
              id="appendText"
              value={config.appendText}
              onChange={(e) => setConfig({ ...config, appendText: e.target.value })}
              placeholder="输入的内容将追加到打印内容的最后（在切纸之前）"
              rows={4}
            />
            <p className="text-sm text-muted-foreground">
              此内容将追加到打印内容的最后，支持多行文本
            </p>
          </div>

          <div className="flex gap-2 pt-4">
            <Button onClick={handleSave} className="flex-1">
              保存并返回
            </Button>
            <Button onClick={onBack} variant="outline" className="flex-1">
              取消
            </Button>
          </div>
          <ScanPeerId
            visible={showScanner}
            onScanned={(id) => {
              setConfig({ ...config, desktopPeerId: id });
              setShowScanner(false);
            }}
            onCancel={() => setShowScanner(false)}
          />
        </CardContent>
      </Card>
    </div>
  );
}

